import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { AjaxService } from '../services/ajax.service';
import { UserService } from '../services/user.service';
import { Subscription } from 'rxjs';

interface User {
  id : number,
  firstName : string,
  profile : string,
  lastName : string,
  email : string,
  isActive : boolean
}

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [CommonModule, MatDialogModule, ReactiveFormsModule,MatSnackBarModule],
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent {
 
  signUpForm = new FormGroup({
    firstName : new FormControl('', Validators.required),
    lastName : new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', Validators.required),
  });
  submitted = false;
  users : User[] = []
  schoolId = 0
  private subscription : Subscription[] = [];

  @ViewChild('userModal') userModal: any;
  constructor (public dialog: MatDialog, private _snackBar: MatSnackBar, private _ajaxService : AjaxService, private _userService : UserService) {}

  ngOnInit() {
    this.subscription.push(this._userService.getSchoolId().subscribe(value => {
      this.schoolId = value || 0
      this.getGuestUsers()
    }))
  }


  get f() { return this.signUpForm.controls; }

  swicgToggle (id: number, index: any) {
    if (this.users[index].id == id) {
      this._ajaxService.get(`users/deActivateUser/${id}/${this.schoolId}`,).then((response: any) => {
        this._snackBar.open(`User Updated`, "OK", { duration: 3000 })
        this.users[index]['isActive'] = !this.users[index]['isActive']
      })
      .catch(error => {
        let displayError = error.error.message
        if (error.error.message === undefined) displayError = `Technical Issue Please Try Again!`
        this._snackBar.open(`${displayError}`, "OK", { duration: 3000, panelClass: "error-dialog" })
      })
    }
  }

  openDialog() {
    this.dialog.open(this.userModal, {width : '600px'});
  }

  closeDialog() {
    this.submitted = false;
    this.dialog.closeAll();
  }

  onSubmit() {
    this.submitted = true
    if (this.signUpForm.valid) {
      const {firstName, lastName, email, password} = this.signUpForm.value
      const request = {
        firstName : firstName, 
        lastName : lastName, 
        email : email, 
        password : password, 
        schoolId : this.schoolId
      }
      this._ajaxService.post(`users/addGuestUser`, request).then((response: any) => {
        this.closeDialog();
        this.getGuestUsers();
        this._snackBar.open('Guest User Added', 'OK', {duration : 3000})
      }).catch(error => {
        let displayError = error.error.message
        if (error.error.message === undefined) displayError = `Technical Issue Please Try Again!`
        this._snackBar.open(`${displayError}`, "OK", { duration: 3000, panelClass: "error-dialog" })
      })
    }
  }

  getGuestUsers() {
    this._ajaxService.get(`users/getGuestUser/${this.schoolId}`,).then((response: any) => {
      this.users = response.data
    })
  }

  deActivateUser(userId : any) {
    
  }

  ngOnDestroy() {
    this.subscription.forEach(value => {
      value.unsubscribe();
    })
  }
}
